import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const DatePickerField = ({ name, value, onChange, label, ...props }) => {
  const years = Array.from({ length: 40 }, (_, i) => i + 1990);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return (
    <div className='flex'>
      <label htmlFor={props.id || props.name}> {label}</label>
      <DatePicker
        renderCustomHeader={({ date, changeYear, changeMonth }) => (
          <div
            style={{
              margin: 10,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <select
              value={date.getYear() + 1900}
              onChange={(e) => changeYear(e.target.value)}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        )}
        selected={(value && new Date(value)) || null}
        {...props}
        onChange={(val) => {
          onChange(name, val);
        }}
        className='mt-1 p-2 w-full rounded-md border  border-gray-300 shadow-sm  sm:text-sm  focus:outline-none'
      />
    </div>
  );
};
